export default function SourcesList({ sources = [] }) {
  return (
    <div className="src-list">
      {sources.map((s, i) => (
        <div key={i} className="src-row">
          <div className="src-ico" style={{ background: s.color }}>{s.initial}</div>
          <div>
            <div className="src-pub">{s.publisher}</div>
            <div className="src-ttl">{s.title}</div>
            <div className="src-meta">
              <span className={s.credibility >= 80 ? 'cred-hi' : 'cred-mid'}>
                {s.credibility}
              </span>
              {s.meta}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
